document.addEventListener("DOMContentLoaded", function () {

  function convertTooltips(container) {
    if (!container) return;

    container.innerHTML = container.innerHTML.replace(
      /([^{(]+)\(\(([^)]+)\)\)/g,
      '<span>$1</span><span class="tooltip"><sup class="tooltip-icon">ⓘ</sup><span class="tooltip-text">$2</span></span>'
    );
  }

  // Produktbeschreibung
  document.querySelectorAll(".rte").forEach(function (element) {
    convertTooltips(element);
  });

  // Metafelder / Produktinformationen
  document.querySelectorAll(
    ".product__description, .product__info-container, .product__accordion, .accordion__content"
  ).forEach(function (element) {
    convertTooltips(element);
  });

});